<template>
  <div id="recordList" class="hub-grey">
    <div class="list-top">
      <h1>Record</h1>
    </div>

    <ul class="record-list">
      <li class="list-head">
        <div class="col-module">Module Name</div>
        <div class="col-theme">Theme Name</div>
        <div class="col-host">ClientID</div>
        <div class="col-date">Date</div>
        <div class="col-time">Time</div>
      </li>

      <li v-for="(monthObject, index) in monthList" :key="index">
        <MonthContainer
          :id="`records-m${monthObject.month}-y${monthObject.year}`"
          :month="monthObject.month"
          :records="monthObject.records"
        />
      </li>
    </ul>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { useRoute } from 'vue-router';

import MonthContainer from '@/components/profile/PersonalMonthRecordList.vue';
import RecordService from '@/services/record';
import useSessionStore from '@/stores/session';

const $route = useRoute();
const SessionStore = useSessionStore();
const monthList = ref([]);

const learningTypeKey = computed(() => {
  return $route.path.split('/').pop();
});

function parseRecordsIntoMonths(records) {
  return records
    .map((record) => {
      // easier to work with time as a Date object
      // remove extras from module name
      // check for type of dash
      let dashType = null;
      if (record.moduleName.includes('\x2d')) {
        dashType = '\x2d';
      } else if (record.moduleName.includes('\u2013')) {
        dashType = '\u2013';
      } else if (record.moduleName.includes('\u2014')) {
        dashType = '\u2014';
      }
      return {
        moduleName: record.moduleName.substring(record.moduleName.indexOf(dashType) + 1, record.moduleName.length),
        // moduleName: record.moduleName,
        themeName: record.themeName,
        startTime: new Date(record.startTime),
        endTime: new Date(record.endTime),
        clientID: record.clientCode,
      };
    })
    .reduce((ac, record) => {
      let acc = ac;
      // create an array of months and place records within their month
      const monthIndex = acc.findIndex(
        (monthRecord) =>
          monthRecord.month === record.endTime.getMonth() && monthRecord.year === record.endTime.getFullYear()
      );

      if (monthIndex > -1) {
        // push record into existing month segment
        acc[monthIndex].records.push(record);
      } else {
        // add new month segment
        acc = acc.concat({
          month: record.endTime.getMonth(),
          year: record.endTime.getFullYear(),
          records: [record],
        });
      }
      return acc;
    }, [])
    .sort(
      (
        segA,
        segB // sort by month, descending
      ) => (segA.year === segB.year ? segB.month - segA.month : segB.year - segA.year)
    );
}

async function getRecordList() {
  const data = await RecordService.getFacilitatorRecords(SessionStore.loginUser.id, learningTypeKey.value);
  monthList.value = parseRecordsIntoMonths(data.records);
}

watch(
  learningTypeKey,
  () => {
    getRecordList();
  },
  { immediate: true }
);
</script>

<style scoped>
#recordList {
  padding: 3em 0;
}

.list-top > h1 {
  margin: 0;
  text-align: center;
}

.record-list {
  display: grid;
  grid-template-columns: repeat(1, 88%);
  row-gap: 3em;
  justify-content: space-evenly;

  margin-top: 3em;
  /* font-size: 1.1em; */
}

.list-head {
  display: none;
}

/** Larger devices */
@media only screen and (min-width: 601px) and (min-height: 601px) {
  .list-head {
    display: grid;
    grid-template-areas: 'a b c d e';
    grid-template-columns: 26% 20% 16% 20% 10%;
    justify-content: space-between;

    margin: 0 2em 2em 4em;
    border-bottom: 1px solid #6d6e71;
    padding: 1em 0.5em;
  }

  .record-list {
    row-gap: 0;
  }
}
</style>
